import { gql } from '@apollo/client'
import { PLANOGRAM_FEEDBACK_IMAGES_ISSUES_FRAGMENT } from '../fragments/PlanogramFeedbackImagesIssuesFragment'

export const GET_PLANOGRAM_FEEDBACK_IMAGE_BY_ID = gql`
  query GetPlanogramFeedbackImageById($input: ID!) {
    planogramFeedbackImageById(input: $input) {
      ...PlanogramFeedbackImagesIssues
    }
  }
  ${PLANOGRAM_FEEDBACK_IMAGES_ISSUES_FRAGMENT}
`
